import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export function useGetTabInfo(_ref) {
  var getTabLink = _ref.getTabLink,
    getIsActiveTab = _ref.getIsActiveTab,
    routes = _ref.routes,
    location = _ref.location,
    playlistId = _ref.playlistId;
  // List of tabs to iterate over
  var tabs = ['details', 'content', 'contentPreview', 'analytics', 'access', 'share'];

  // Generate tab links with active states
  var tabLinks = {};
  tabs.forEach(function (tabName) {
    var link = getTabLink({
      tabName: tabName,
      routes: routes,
      location: location
    });
    var isActive = getIsActiveTab({
      location: location,
      playlistId: playlistId,
      tabName: tabName,
      routes: routes
    });
    tabLinks[tabName] = {
      link: link,
      isActive: isActive
    };
  });

  // Find the active tab
  var activeTab = tabs.find(function (tabName) {
    return tabLinks[tabName].isActive;
  }) || 'details';
  return {
    tabLinks: tabLinks,
    activeTab: activeTab
  };
}